<div class="template-view-wrapper">
  <div class="template-header main-grid-container">
    <div class="template-selector-grid-container">
      <span>Template Name</span>
      <span
        data-cy="add-budget-template-button"
        (click)="addTemplateClicked()"
        class="col-start-3 icon-add-block-square text-blue-700 text-[22px]"
      ></span>
    </div>
    <div
      [ngClass]="{
        'budget-manager': userService.isManager,
        'budget-gc': userService.isPremiumSP,
        'mr-[21px]':
          templateItemsContainer()?.nativeElement?.scrollHeight > templateItemsContainer()?.nativeElement?.offsetHeight,
        'mr-[11px]':
          templateItemsContainer()?.nativeElement?.scrollHeight <= templateItemsContainer()?.nativeElement?.offsetHeight
      }"
      class="template-lines-grid-container mb-0"
    >
      @if (userService.isManager) {
        <div class="col-start-3">Account Code</div>
      } @else if (userService.isPremiumSP) {
        <div class="col-start-3">Division</div>
        <div class="">Cost type</div>
      }
      <div>Description</div>
      <div
        [ngClass]="{
          'col-start-5': userService.isManager,
          'col-start-6': userService.isPremiumSP
        }"
      >
        <app-upload-window
          (chosenFiles)="spreadSheetLoaded($event)"
          iconClass="icon-folded-file-upload text-[22px] cursor-pointer hover:brightness-[117%]"
          acceptFileTypes=".xlsx"
        ></app-upload-window>
      </div>
      <div #exportTemplateBtn="cdkOverlayOrigin" cdkOverlayOrigin (click)="isDropdownShown = true" class="max-h-[30px]">
        <span class="icon-download-template text-[22px] text-navy-700 cursor-pointer hover:brightness-[117%]"></span>
      </div>
      <app-overlay-general
        [trigger]="exportTemplateBtn"
        [(show)]="isDropdownShown"
        (close)="isDropdownShown = false"
        [overlayPositions]="defaultDropdownOverlayPositions"
      >
        <div class="bg-color-white shadow-md p-2">
          <div
            (click)="exportOneTemplate()"
            [ngClass]="{ 'disabled text-navy-500': !(selectedTemplate$ | async)?.template_items?.length }"
            class="cursor-pointer text-size_l font-semibold text-navy-700 hover:text-yellow-500"
          >
            Export only this template
          </div>
          <div
            (click)="exportAllTemplates()"
            class="cursor-pointer text-size_l font-semibold text-navy-700 hover:text-yellow-500"
          >
            Export all templates
          </div>
        </div>
      </app-overlay-general>
    </div>
  </div>

  <div class="main-grid-container flex-1 min-h-0">
    @if ((templates$ | async).length === 0) {
      <app-splash-screen class="col-start-1 col-end-3" title="You currently don't have any project templates.">
        <app-simple-button buttonStyle="color_secondary_filled" size="large" (click)="addTemplateClicked()"
          >Add a Template</app-simple-button
        >
      </app-splash-screen>
    } @else {
      <app-template-list type="budget"></app-template-list>
      @if (!templateItems?.length) {
        <div>
          <app-splash-screen
            class="col-start-1 col-end-8"
            title="There are no template lines to show."
          ></app-splash-screen>
        </div>
      } @else {
        <div
          #templateItemsContainer
          cdkDropList
          cdkScrollable
          cdkDropListOrientation="vertical"
          [cdkDropListData]="templateItems"
          (cdkDropListDropped)="itemDropped($event)"
          class="mr-2 my-2 cdk-scrollable items-container"
          [ngClass]="{
            'is-gc': userService.isPremiumSP
          }"
        >
          @for (templateItem of templateItems; track templateItem.id; let index = $index) {
            <div cdkDrag [cdkDragData]="templateItem" class="item-container">
              <div
                [ngClass]="{
                  'budget-manager': userService.isManager,
                  'budget-gc': userService.isPremiumSP
                }"
                class="template-lines-grid-container"
              >
                <app-template-item-project-budget
                  [template]="selectedTemplate$ | async"
                  [templateItem]="templateItem"
                ></app-template-item-project-budget>
              </div>

              @if (isGCTemplate(templateItem)) {
                <div
                  class="subitems-container"
                  cdkDropList
                  [cdkDropListData]="templateItem.subitems"
                  (cdkDropListDropped)="subitemDropped($event, templateItem)"
                >
                  @for (subItem of templateItem?.subitems ?? []; track subItem.id; let subIndex = $index) {
                    <div
                      cdkDrag
                      [cdkDragData]="subItem"
                      [ngClass]="{
                        'budget-manager': userService.isManager,
                        'budget-gc': userService.isPremiumSP
                      }"
                      class="template-lines-grid-container"
                    >
                      <app-template-subitem
                        [template]="selectedTemplate$ | async"
                        [templateItem]="templateItem"
                        [templateSubitem]="subItem"
                      ></app-template-subitem>
                    </div>
                  }
                </div>
              }
            </div>
          }

          @if (userService.isPremiumSP) {
            <div
              class="template-lines-grid-container"
              [ngClass]="{
                'budget-manager': userService.isManager,
                'budget-gc': userService.isPremiumSP
              }"
            >
              <div class="col-start-5 flex justify-end items-center">
                <div class="add-group-btn" (click)="addTemplateItem()" data-cy="add-group-button">
                  Add Group
                  <div class="index-box">+</div>
                </div>
              </div>
            </div>
          }
        </div>
      }
    }
  </div>
</div>
